module.exports = {"id":"dp1_2l3q1","text":"Evaluating Information","instructions":"What is the main purpose of fact-checking services?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":true,"options":[{"id":"dp1_2l3q1-a1","text":"Verify accuracy","score":3.7},{"id":"dp1_2l3q1-a2","text":"Increase sharing","score":1.3},{"id":"dp1_2l3q1-a3","text":"Promote opinions","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l3q1.json
// module id = 949
// module chunks = 41